import React, { useContext, useEffect, useState } from 'react';

import './PeligrosSubtabla.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import FormPeligro from '../FormPeligro/FormPeligro.js';

import peligroContext from '../../context/peligroContext/peligroContex.js';
import { SECUNDARY_COLOR } from '../../constants/colors';
import { estructuraPeligro } from '../../utils/estructuras.js';

const PeligrosSubtabla = ({peligros, setState, tablaSeleccionada, tDocID='', checkboxMode=false}) =>{

    const [data,setData] = useState('');
    const [showAddPeligro,setShowAddPeligro] = useState(false);
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState([]);

    const pContext = useContext(peligroContext);
    const {peligroIDLista} = pContext;

    const minimizar = () => {
        setShowAddPeligro(false);
    }

    const createOptions = () => {
        const copyPeligros = JSON.stringify(peligroIDLista)
        const peligrosList = JSON.parse(copyPeligros)
        let optionsP = [];
        if(peligrosList.length > 0){
            optionsP = peligrosList.map((p) => {return {
                label:p.name, value: p.codPeligro, id: p['_id'], name:p.name
            }})
        }
        setOptions({opcionesPeligros:optionsP});
    }

    // === Funciones modo checkbox ===
    const findCheckedPeligro = (catalogPeligro) => {
        if(!peligros || peligros.length === 0) return null;
        return peligros.find(p => p.value === catalogPeligro.codPeligro || p.codPeligro === catalogPeligro.codPeligro);
    }

    const handleTogglePeligro = (catalogPeligro, checked) => {
        setState((prevState) => {
            let currentPeligros = prevState.peligros ? prevState.peligros.filter(p => p.label !== '') : [];

            if(checked) {
                const existing = currentPeligros.find(p => p.value === catalogPeligro.codPeligro || p.codPeligro === catalogPeligro.codPeligro);
                if(!existing) {
                    currentPeligros.push({
                        value: catalogPeligro.codPeligro,
                        label: catalogPeligro.name,
                        id: catalogPeligro._id,
                        codPeligro: catalogPeligro.codPeligro,
                        name: catalogPeligro.name,
                        textAdic: ''
                    });
                }
            } else {
                currentPeligros = currentPeligros.filter(p =>
                    p.value !== catalogPeligro.codPeligro && p.codPeligro !== catalogPeligro.codPeligro
                );
            }

            return {...prevState, peligros: currentPeligros};
        });
    }

    const handleChangeTextAdic = (catalogPeligro, textAdic) => {
        setState((prevState) => {
            let currentPeligros = prevState.peligros ? prevState.peligros.slice() : [];
            const index = currentPeligros.findIndex(p => p.value === catalogPeligro.codPeligro || p.codPeligro === catalogPeligro.codPeligro);
            if(index > -1) {
                currentPeligros[index] = {...currentPeligros[index], textAdic};
            }
            return {...prevState, peligros: currentPeligros};
        });
    }

    const handleChangePeligrosCheckbox = (peligro = {}, index) => {
        if(Object.keys(peligro).length === 0) {
            setState((prevState) => {
                let currentPeligros = prevState.peligros ? prevState.peligros.slice() : [];
                currentPeligros = currentPeligros.filter(p =>
                    p.value !== data.value && p.codPeligro !== data.codPeligro
                );
                return {...prevState, peligros: currentPeligros};
            });
        } else {
            setState((prevState) => {
                let currentPeligros = prevState.peligros ? prevState.peligros.slice() : [];
                const idx = currentPeligros.findIndex(p => p.id === peligro.id || p.value === peligro.value);
                if(idx > -1) {
                    currentPeligros[idx] = {...currentPeligros[idx], ...peligro};
                }
                return {...prevState, peligros: currentPeligros};
            });
        }
    }

    // === Funciones modo tradicional (dropdown) ===
    const handleChangePeligros = (peligro = {},i,textAdic = undefined) => {
        setState((prevState) => {
            let prePeligros = prevState.peligros.slice();
            const copyPeligros = JSON.stringify(prePeligros)
            const peligrosArr = JSON.parse(copyPeligros)

            if(textAdic != undefined && Object.keys(peligro).length == 0){
                if(peligrosArr[i].value !== ''){
                    peligrosArr[i].textAdic = textAdic;
                }
                let newState = {...prevState,['peligros']:peligrosArr};
                return newState;
            }else{
                if(Object.keys(peligro).length == 0){
                    peligrosArr.splice(i,1);
                }
                else if(peligrosArr[i].value !== ''){
                    peligrosArr[i] = peligro;
                    peligrosArr[i].textAdic = "";
                }else{
                    peligrosArr[i] = peligro;
                    peligrosArr[i].textAdic = "";
                    peligrosArr.push({...estructuraPeligro});
                }
                let newState = {...prevState,['peligros']:peligrosArr};
                return newState;
            }
        })
    }

    const handleDeletePeligro = (peligro,index) => {
        setState((prevState) => {
            let peligrosArr = prevState.peligros.slice();
            if(peligrosArr.length > 0 && index > -1 && peligro.label !== ''){
                peligrosArr = prevState.peligros.filter((p,i) => i !== index);
            }
            let newState = {...prevState,['peligros']:peligrosArr};
            return newState;
        });
    }

    useEffect(()=>{
        createOptions();
    },[peligroIDLista])

    return <div className={`${(tablaSeleccionada != 'peligros') && 'inactive'} peligrosDiv`}>
    <label>Peligros Posibles</label>
    <div className="peligrosXtransactionDoc">
        {checkboxMode ? (
            // === MODO CHECKBOX ===
            <>
            {(!peligroIDLista || peligroIDLista.length === 0) ? <div style={{display:'flex', alignItems:'center', gap:'0.5rem'}}>
                <h5 style={{marginBottom:0}}>No hay peligros cargados en el sistema.</h5>
                <button className="button-add-form" style={{backgroundColor: SECUNDARY_COLOR, borderRadius:'5px', padding:'0.25rem 1rem', fontSize:'1.2rem'}} onClick={() => { setNuevoEditado("Agregar"); setData(''); setShowAddPeligro(true); }}>+</button>
            </div> :
            peligroIDLista.map((catalogPeligro, i) => {
                const checkedPeligro = findCheckedPeligro(catalogPeligro);
                const checked = !!checkedPeligro;
                return <div className="peligroDiv" key={`${catalogPeligro.codPeligro}-${i}`}>

                    <SelectControl placeholder={"Seleccione un peligro..."} modo={"Nuevo"} setShowAdd={setShowAddPeligro} idSelect={"peligro"} handleChengeSelect={()=>{}} optionsSelect={options.opcionesPeligros} valueSeleccionada={{value: catalogPeligro.codPeligro, label: catalogPeligro.name, id: catalogPeligro._id, name: catalogPeligro.name}} tipo={'peligroOT'} selectSelect={()=>{}} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                    <label className='customCheckbox'>
                        <input value={checked} className='checkboxTask' type='checkbox' checked={checked} onChange={(e) => handleTogglePeligro(catalogPeligro, e.target.checked)}/>
                        <span className={`${checked ? 'checked' : ''}`}></span>
                    </label>

                    <input className="inputTextAdic" name="textAdic" value={checked ? (checkedPeligro.textAdic || '') : ''} onChange={(e) => handleChangeTextAdic(catalogPeligro, e.target.value)} placeholder="Ingrese texto adicional..." disabled={!checked}/>
                </div>
            })
            }
            </>
        ) : (
            // === MODO TRADICIONAL (DROPDOWN) ===
            <>
            {(peligros == undefined) ? <h5>Cargando Peligros...</h5> :
            peligros.length > 0 && peligros.map((peligro,i) =><div className="peligroDiv" key={`${peligro.codPeligro}-${i}`}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeletePeligro(peligro,i)} />

                <SelectControl placeholder={"Seleccione un peligro..."} modo={"Nuevo"} setShowAdd={setShowAddPeligro} idSelect={"peligro"} handleChengeSelect={handleChangePeligros} optionsSelect={options.opcionesPeligros} valueSeleccionada={peligro} tipo={'peligroOT'} selectSelect={handleChangePeligros} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                <input className="inputTextAdic" name="textAdic" value={peligro.textAdic} onChange={(e) => handleChangePeligros({},i,e.target.value)} placeholder="Ingrese texto adicional..."/>
            </div>)
            }
            </>
        )}
        {showAddPeligro && <FormPeligro data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangePeligros={checkboxMode ? handleChangePeligrosCheckbox : handleChangePeligros} index={indexToUpdate} tDocID={tDocID}/> }
    </div>
    </div>
}

export default PeligrosSubtabla;
